import { PartnerInfoListInterface } from "../interface/partner.interface";

export const PARTNER_INFO: PartnerInfoListInterface = {
	carsome: {
		isDisplay: true,
		partner: "carsome",
		company: "Carsome",
		email: { value: "capital.insurance@carsome.my", isDisplay: true },
		mobile: { value: "", isDisplay: false },
		address: {
			value:
				"Level 9, KYM Tower, No. 8, Jalan PJU 7/6, Mutiara Damansara, 47800 Petaling Jaya, Selangor",
			isDisplay: false
		},
		copyright: { value: "Carsome Sdn Bhd (201401025864)", isDisplay: true },
		whatsapp: { value: 0, isDisplay: false }
	},
	mg: {
		isDisplay: true,
		partner: "mg",
		company: "MG",
		email: { value: "customerservice@policystreet.com", isDisplay: true },
		mobile: { value: "+6018-351 2322 (WA message only)", isDisplay: true },
		address: {
			value:
				"Level 9, KYM Tower, No. 8, Jalan PJU 7/6, Mutiara Damansara, 47800 Petaling Jaya, Selangor",
			isDisplay: false
		},
		copyright: {
			value: "© Copyright 2025 MG Motor | All Rights Reserved",
			isDisplay: true
		},
		whatsapp: { value: 60183512322, isDisplay: true }
	},
	fundingsocieties: {
		isDisplay: true,
		partner: "fundingsocieties",
		company: "Funding Societies",
		email: { value: "customerservice@policystreet.com", isDisplay: true },
		mobile: { value: "+6018-351 2322 (WA message only)", isDisplay: true },
		address: {
			value:
				"Level 9, KYM Tower, No. 8, Jalan PJU 7/6, Mutiara Damansara, 47800 Petaling Jaya, Selangor",
			isDisplay: false
		},
		copyright: {
			value: "© Copyright 2025 Funding Societies | All Rights Reserved",
			isDisplay: true
		},
		whatsapp: { value: 60183512322, isDisplay: true }
	},
	imotorbike: {
		isDisplay: true,
		partner: "imotorbike",
		company: "imotorbike",
		email: { value: "customerservice@policystreet.com", isDisplay: true },
		mobile: { value: "+6018-351 2322 (WA message only)", isDisplay: true },
		address: {
			value:
				"Level 9, KYM Tower, No. 8, Jalan PJU 7/6, Mutiara Damansara, 47800 Petaling Jaya, Selangor",
			isDisplay: false
		},
		copyright: {
			value: "© Copyright 2025 IMotorbike | All Rights Reserved",
			isDisplay: true
		},
		whatsapp: { value: 60183512322, isDisplay: true }
	}
};
